import React from 'react'
// import { Link } from "react-router-dom";
function Footer() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    return (
        <>
            <footer>
                <div className="top-line-theme"></div>
                <div className="row">
                    <div className=" col-lg-12">
                        <div className="row footer-right-links">
                            <div className="col-lg-3">
                                <h6>Text & Document Translation</h6>
                                <ul>
                                    <li className="drop-menu-item">
                                        <a href="https://translation.aicte-india.org/translation-independent/">
                                            Online Document Translation Tool
                                            including Online Editor
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://translation.aicte-india.org/translation-independent/Text-Editor/">
                                            Chutki
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://anuvadiniqa.aicte-india.org/">
                                            Ananta
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://anuvadini.aicte-india.org/voiceform/">
                                            Voice Based Multilingual Form
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://translation.aicte-india.org/translation-independent/PmModiNationalInternshipPortal/">
                                            Video Translation
                                        </a>
                                    </li>

                                    <li className="drop-menu-item">
                                        <a href="https://translation.aicte-india.org/translation-independent/transliterate/">
                                            Virtual Keyboard
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://anuvadini.aicte-india.org/govtofindiascheme/">
                                            Govt of Bharatiya Schemes &
                                            Initiatives Voice Based Search
                                        </a>
                                    </li>

                                    <li className="drop-menu-item">
                                        <a href="https://anuvadini.aicte-india.org/dictation-tool/">
                                            Dictation Tool
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://anuvadini.aicte-india.org/lawdictionary/">
                                            Legal Glossary
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://anuvadini.aicte-india.org/Bhasha-daan/">
                                            Bhasha Daan
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-3">
                                <h6>Voice</h6>
                                <ul>
                                    <li className="drop-menu-item">
                                        <a href="https://voice.aicte-india.org/">
                                            Bhashin
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href="https://voice.aicte-india.org/">
                                            Text to Text Translation
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/ThreeDAudio"
                                            onClick={scrollToTop}
                                        >
                                            3D Audio
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/AutoPartner"
                                            onClick={scrollToTop}
                                        >
                                            {' '}
                                            Auto Panner
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/BassBooster"
                                            onClick={scrollToTop}
                                        >
                                            Bass Booster
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/Equalizer"
                                            onClick={scrollToTop}
                                        >
                                            Equalizer
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/NoiseReducer"
                                            onClick={scrollToTop}
                                        >
                                            Noise Reducer
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/PitchShifter"
                                            onClick={scrollToTop}
                                        >
                                            Pitch Shifter
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/Reverb"
                                            onClick={scrollToTop}
                                        >
                                            Reverb
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/reverseAudio"
                                            onClick={scrollToTop}
                                        >
                                            Reverse Audio
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/stereoPanner"
                                            onClick={scrollToTop}
                                        >
                                            Stereo Panner
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/tempoChanger"
                                            onClick={scrollToTop}
                                        >
                                            Tempo Changer
                                        </a>
                                    </li>
                                    {/* <li className="drop-menu-item"><a href="https://anuvadini.aicte-india.org/trimmerCutter"> Trimmer / Cutterd</a></li> */}
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/vocalRemover"
                                            onClick={scrollToTop}
                                        >
                                            Vocal Remover
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/volumeChanger"
                                            onClick={scrollToTop}
                                        >
                                            {' '}
                                            Volume Changer
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="col-lg-3">
                                {/* <h6>Meeting</h6>
                    <ul>
                        <li className="drop-menu-item"><a href="https://translation.aicte-india.org/translation-independent/transliterate/">Virtual Keyboardd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Screen Recordingd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Video Recordingd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Meeting Captured</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Multi-Camera Recordingd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Phone as Webcamd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Teleprompterd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Remove Camera Backgroundd</a></li>
                    </ul>
                    <br/> */}
                                <h6>File</h6>
                                <ul>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/mkb100/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Mann ki baat (100th episode
                                            celebration) Citizen feedback Form
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href={undefined}>PDF</a>
                                    </li>
                                </ul>
                                <br />
                                <h6>Education</h6>
                                <ul>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/core-engg"
                                            onClick={scrollToTop}
                                        >
                                            Core Engineering AI
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a href={undefined}>Killer - CV</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-3">
                                <h6>Image</h6>
                                <ul>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/image-23/"
                                            onClick={scrollToTop}
                                        >
                                            JaduiDarpan
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/PassportPhotoMaker"
                                            onClick={scrollToTop}
                                        >
                                            Passport Photo Maker
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/ImageBackgroundRemover"
                                            onClick={scrollToTop}
                                        >
                                            Image Background Remover
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/RemoveUnwantedObjects"
                                            onClick={scrollToTop}
                                        >
                                            Remove Unwanted Objects
                                        </a>
                                    </li>
                                    <li className="drop-menu-item">
                                        <a
                                            href="https://anuvadini.aicte-india.org/FaceCutout"
                                            onClick={scrollToTop}
                                        >
                                            Face Cutout
                                        </a>
                                    </li>
                                </ul>
                                <br />
                                <h6>Other Links</h6>
                                <ul>
                                    <li>
                                        <a
                                            href="https://anuvadini.aicte-india.org/AboutUs"
                                            onClick={scrollToTop}
                                            title="About Us"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://anuvadini.aicte-india.org/AboutUs"
                                            onClick={scrollToTop}
                                            title="Contact Us"
                                        >
                                            Contact Us
                                        </a>
                                    </li>
                                </ul>
                                {/* <h6>Video</h6>
                    <ul>
                        <li className="drop-menu-item"><a href={undefined}>Video Background Removerd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Video with Voiced</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Text to Videod</a></li>
                        <li className="drop-menu-item"><a href={undefined}>AI Video Generatord</a></li>
                        <li className="drop-menu-item"><a href={undefined}>AI Summaryd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>Brandingd</a></li>
                        <li className="drop-menu-item"><a href={undefined}>AI Video Analyzerd</a></li>
                    </ul> */}
                            </div>
                            {/* <div className="col-lg-2">
                    <h6>Other Links</h6>
                    <ul>
                        <li><a href="https://anuvadini.aicte-india.org/AboutUs" title="About Us" onClick={scrollToTop}>About Usd</a></li>
                        <li><a href={undefined} title="Contact Us" onClick={scrollToTop}>Contact Usd</a></li>
                    </ul>
                </div> */}
                        </div>
                    </div>
                </div>
                <br />
                <hr />
                <br />
                <center>
                    <div className="footer-links">
                        <ul>
                            <li>
                                <a
                                    href="https://anuvadini.aicte-india.org/PrivacyPolicy"
                                    title="Privacy Policy"
                                    onClick={scrollToTop}
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            |
                            <li>
                                <a
                                    href="https://anuvadini.aicte-india.org/tirmOfUse"
                                    title="Term of Use"
                                    onClick={scrollToTop}
                                >
                                    Term of Use
                                </a>
                            </li>
                            |
                            <li>
                                <a
                                    href="https://anuvadini.aicte-india.org/cookies-policy"
                                    title="Cookie Policy"
                                    onClick={scrollToTop}
                                >
                                    Cookie Policy
                                </a>
                            </li>
                        </ul>
                    </div>
                </center>
                <br />
                <center>
                    © 2023 All rights reserved, AICTE<sup>®</sup>
                </center>
            </footer>
        </>
    )
}

export default Footer
